import styled from 'styled-components'
import { LoginFormUnstyled } from './unstyled'

export const LoginForm = styled(LoginFormUnstyled)`
  position: relative;
  width: 100%;
  height: 100%;

  .form-container {
    position: absolute;
    width: 100%;
    max-width: 360px;
    left: 0;
    right: 0;
    top: 50%;
    margin: auto;
    transform: translateY(-50%);
  }
  .form-container .under-form .link-wrapper:nth-child(1) {
    display: block;
    margin: 20px 0 0 0;
  }
  input[type='submit'] {
    margin: 38px 0 0 0;
  }
  .form-inputs .text-input-wrapper {
    margin: 40px 0 0 0;
  }
  .form-inputs .password-input-wrapper {
    margin: 13px 0 0 0;
  }
  h1 {
    font-size: 28px;
    margin: 0;
  }
  p {
    display: inline-block;
    margin: 75px 0 0 0;
  }
  p + .link-wrapper {
    margin-left: 10px;
  }
  .link-wrapper {
    display: inline-block;
  }
  button {
    margin-top: 20px;
  }
`



// WEBPACK FOOTER //
// ./src/Containers/Form/Login/index.js